module.exports = __webpack_public_path__ + "static/img/1.2fe13dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/zh/1.png
// module id = Noku
// module chunks = 0